import { FC } from 'react';
import { Activity } from '../../graphql/generated/graphql.ts';
import { Stack, Typography } from '@mui/material';
import { addDays, format, startOfWeek } from 'date-fns';
import { DeepPartial } from '@apollo/client/utilities';
import { ActivityDisplay } from './activity-display.tsx';

export interface DayDisplayProps {
  day: number;
  activities?: DeepPartial<Activity[]>;
}

export const DayDisplay: FC<DayDisplayProps> = ({ day, activities }) => {
  const date = addDays(startOfWeek(new Date(), { weekStartsOn: 1 }), day);
  const d = format(date, 'EEEE');
  const activityOnDay: Activity[] = activities?.filter((activity) => {
    return activity?.schedule?.find((dayAndPeriod) => dayAndPeriod?.day === d);
  }) as Activity[];
  if (!activityOnDay || activityOnDay.length === 0) {
    return null;
  }
  const morning = activityOnDay.filter((activity) => {
    return activity?.schedule?.find((dayAndPeriod) => dayAndPeriod?.day === d && dayAndPeriod?.period.includes('Morning'));
  });
  const afternoon = activityOnDay.filter((activity) => {
    return activity?.schedule?.find((dayAndPeriod) => dayAndPeriod?.day === d && dayAndPeriod?.period.includes('Afternoon'));
  });
  const evening = activityOnDay.filter((activity) => {
    return activity?.schedule?.find((dayAndPeriod) => dayAndPeriod?.day === d && dayAndPeriod?.period.includes('Evening'));
  });
  return (
    <>
      <Typography variant="h6">{format(date, 'EEEE, MMM do')}</Typography>
      <Typography variant="body1">
        <Stack spacing={1}>
          {morning?.map((activity) => {
            return <ActivityDisplay day={d} key={activity?._id} activity={activity} period="Morning" />;
          })}
          {afternoon?.map((activity) => {
            return <ActivityDisplay day={d} key={activity?._id} activity={activity} period="Afternoon" />;
          })}
          {evening?.map((activity) => {
            return <ActivityDisplay day={d} key={activity?._id} activity={activity} period="Evening" />;
          })}
        </Stack>
      </Typography>
    </>
  );
};
